

















































































import Vue from 'vue'
import mixins from 'vue-typed-mixins'

import TreatmentMixin from '../TreatmentMixin'
import SewipTherapists from '@/survey/measures/sewip/SewipTherapists.vue'

export default mixins(TreatmentMixin).extend({
  components: {
    SewipTherapists,
  },
  props: {
    letter: {
      type: Number,
      required: true,
    },
  },
})
